// extracted by mini-css-extract-plugin
export default {"list":"Specialists_list__HemX8","hover":"Specialists_hover__kiigR","text":"Specialists_text__XMOnW","entrance":"Specialists_entrance__3Mwic"};